import { useMemo } from 'react';
import {
	EngagementSpotlight,
	EngagementInlineDialog,
	Coordination,
	useCoordination,
} from '@atlassiansox/engagekit-ts';

import type { EngagementPlatformPluginConfig } from '@atlaskit/editor-plugin-engagement-platform';

import { useCoordinationClient } from '@confluence/engagement-provider';

export const useEditorEngagementPlatform = () => {
	const coordinationClient = useCoordinationClient();

	// [ED-27497] IMPORTANT: If you change the code below, please also update the
	// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/engagementPlatformPluginOptions.ts
	return useMemo(() => {
		const config: EngagementPlatformPluginConfig = {
			epComponents: {
				EngagementSpotlight,
				EngagementInlineDialog,
				Coordination,
			},
			epHooks: {
				useCoordination,
			},
			coordinationClient,
		};

		return {
			config,
		};
	}, [coordinationClient]);
};
